import Card from 'features/shared/components/card/Card';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

type Props = {}

const AdditionalInfoSection = (props: Props) => {
  // tranlations
  const { t } = useTranslation("additionalInfo\\additionalInfo");

  // render
  return (
    <Card className="p-4">
      <div dangerouslySetInnerHTML={{ __html: t("additionalInfoSection.content") || "" }} />
    </Card>
  )
}

export default AdditionalInfoSection;